import { Container } from "aurelia-dependency-injection";
import React from "react";
import { ApiService } from "Services/ApiService";

export function useService<T extends ApiService>(
  service: new (...args: any[]) => T
): T {
  return React.useMemo(() => Container.instance.get(service), [service]);
}
